export default __webpack_public_path__ + "static/media/828.828e01b9.png";